import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';
import { Grid } from '@mui/material';
import SlotActions from '../actions';
import { useFlowStore } from '@/state/stores/use-flow-store';
import { UpdateBreakForm } from './update-break.form';
import { MediaWidget } from '@/components/events/detail/tabs/common/media/media.widget.tsx';
import { getObjectId } from '@/helpers/object.id.helper';
import { useMemo } from 'react';
import { useFlowMode } from '../../use-flow-mode';

export const UpdateBreakSlot = ({
  slot,
  slotTitle,
  onSlotDeleted,
  showMediaWidget = true,
}: {
  slot: FlowSlotDto<'Break'>;
  slotTitle: string;
  onSlotDeleted?: () => void;
  /** When false, hides MediaWidget (e.g. in flow schedule tab) */
  showMediaWidget?: boolean;
}) => {
  const flow = useFlowStore((s) => s.flow);
  const mode = useFlowMode();
  const media = useMemo(
    () => flow?.media.filter((media) => media.placement?.id === slot.id) ?? [],
    [slot.id, flow?.media],
  );
  if (!flow) return null;

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        {mode !== 'PERFORM' && (
          <UpdateBreakForm
            slot={slot}
            widgetButton={
              <SlotActions slotId={slot.id} slotTitle={slotTitle} flowId={flow.id} onSlotDeleted={onSlotDeleted} />
            }
          />
        )}
      </Grid>
      {showMediaWidget && (
        <Grid size={{ xs: 12 }}>
          <MediaWidget
            media={media}
            parentId={flow?.origin ? getObjectId(flow.origin) : flow.id}
            parentType="Flow"
            entityId={slot.id}
            context="Break"
            placement={{
              id: slot.id,
              type: 'Slot',
            }}
            enablePlayerSocket={mode === 'PERFORM'}
            enabled={mode === 'PERFORM'}
          />
        </Grid>
      )}
    </Grid>
  );
};
